<div class="dialog__body dialog__body--mail">
  <ag-mail-send-flow-dialog
    (closed)="dialog.close()"
    (sent)="dialog.close()"
  ></ag-mail-send-flow-dialog>
</div>
